import { ref, onMounted, onUnmounted } from "vue";

export function useScreenSize(breakpoint = 1024) {
    const isSmallScreen = ref(window.innerWidth <= breakpoint);
    const width = ref(window.innerWidth);

    const handleResize = () => {
        width.value = window.innerWidth;
        isSmallScreen.value = window.innerWidth <= breakpoint;
    };

    onMounted(() => {
        window.addEventListener("resize", handleResize);
    });

    onUnmounted(() => {
        window.removeEventListener("resize", handleResize);
    });

    return {
        width,
        isSmallScreen
    };
}
